import { Locale } from "./locales";
import { PageId } from "./pageId";

export const SurchargeApplicableLocales = [Locale.enUS, Locale.esUS, Locale.enCA, Locale.frCA];
export const SurchargeApplicableCountries = ["US"];
export const SurchargeApplicablePageIds = [PageId.LatPDP, PageId.PDP, PageId.CorePDP];
